"use client";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import { archana_conceptpr, huda_conceptpr, ICM_MAIL } from "@/app/utils/constants";
import React from "react";

const announcementBreadcrumbPaths: BreadcrumbPath[] = [
    { label: "Home", route: "/" },
    { label: "Important Announcement" },
];

const PressRelease = () => {
    return (
        <section
            id="press-main-section"
            className="md:px-auto mx-auto bg-neutral-50 px-6 pb-14 pt-8 md:container md:bg-transparent md:pb-[120px] md:pt-0"
        >
            <Breadcrumb paths={announcementBreadcrumbPaths} />
            <h2
                id="press-release-title"
                className="text-4xl font-semibold leading-[41.6px] md:mb-2 md:text-6xl"
            >
                Press Release
            </h2>
            <p
                id="press-release-subtitle"
                className="mb-4 text-2xl font-semibold md:mb-8 md:text-4xl md:leading-[41.6px]"
            >
                InCred Money launches Fixed Deposits product on its platform
            </p>
            <p id="press-release-content-1" className="mb-8 text-base text-neutral-500">
                FDs of multiple RBI regulated Banks and NBFCs can be accessible on a single app with
                interest rates up to 9.25% p.a. for senior citizens, without the need for opening a
                new savings bank account
            </p>
            <p id="press-release-content-2" className="mb-8 text-base text-neutral-500">
                <b>National, 2nd April 2024:</b> InCred Money (ICM) today announced the launch of
                Fixed Deposits (FDs) product on its InCred Money app, providing investors with a
                streamlined approach to investing in FDs of Banks and Non-Banking Financial
                Companies (NBFCs). This launch aims to simplify the investment process for investors
                and offer high interest rates and enhanced convenience.
            </p>
            <p id="press-release-content-3" className="mb-8 text-base text-neutral-500">
                {`Traditionally, investing in FDs often necessitates opening a savings account with a bank, which may be a deterrent for investors seeking higher FD rates offered by other institutions. InCred Money's platform aims to streamline the process for investors to be able to access a range of FDs on a single platform.`}
            </p>
            <p id="press-release-content-4" className="mb-8 text-base text-neutral-500">
                India’s love for FDs is well-known with more than ₹108 Lakh Crore invested in FDs of
                Scheduled Commercial Banks as of March 2023. Despite FD interest rates plunging to
                around 5.5% in 2021 and 2022, investors continued their faith in FDs with investment
                in FDs growing each year. With FD rates at multi-year highs currently, this affinity
                towards FDs is expected to only strengthen.
            </p>
            <p id="press-release-content-5" className="mb-8 text-base text-neutral-500">
                InCred Money’s newest offering of FDs on its platform is in collaboration with
                RBI-regulated Scheduled Commercial Banks including Small Finance Banks (SFBs) and
                Non-Banking Financial Companies (NBFCs). Investors will be able to invest easily in
                multiple Fixed Deposits via the InCred Money app which is available for download on
                the Android and iOS app stores.
            </p>
            <p id="press-release-content-6" className="mb-8 text-base text-neutral-500">
                In terms of safety, it is to be noted that Bank & NBFC FDs are regulated by RBI.
                Further, there is an insurance of up to ₹5 Lakh by the Deposit Insurance and Credit
                Guarantee Corporation (a 100% RBI subsidiary) on Bank Deposits per PAN per bank.
            </p>
            <p id="press-release-content-7" className="mb-8 text-base text-neutral-500">
                FDs on the InCred Money platform will provide best-in-class interest rates of up to
                9.25% p.a. for senior citizens and up to 9.01% p.a. for regular investors. InCred
                Money offers high convenience by allowing investors to compare FDs from various
                banks and NBFCs on their platform, and invest in the FDs that align best with their
                return and maturity expectations. This entire process can be completed in under 5
                minutes, requiring no new savings bank account to be opened and with a minimum
                investment of just ₹5,000.
            </p>
            <p id="press-release-content-8" className="mb-8 text-base text-neutral-500">
                InCred Money offers high convenience by allowing investors to compare FDs from
                various banks and NBFCs on their platform, and invest in the FDs that align best
                with their return and maturity expectations. This entire process can be completed in
                under 5 minutes, requiring no new savings bank account to be opened and with a
                minimum investment of just ₹5,000.
            </p>
            <p id="press-release-quote" className="mb-14 text-base text-neutral-500">
                <b>Vijay Kuppa, CEO of InCred Money, shared his thoughts on the launch, stating,</b>{" "}
                “With the launch of the FD offerings on our platform, we’re excited to democratize
                financial opportunities and simplify the path to financial wellness. Our new
                offering enables investors to bypass traditional limitations and invest in
                competitive FDs from a range of institutions, all within a single, user-friendly
                app. This launch indicates a financial landscape evolving towards simplicity, where
                the promise of attractive FD rates becomes a reality accompanied by a smooth
                onboarding process.”
            </p>
            <h2
                id="about-incred-title"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About InCred Money:
            </h2>
            <p id="about-incred-content" className="mb-8 text-base text-neutral-500">
                InCred Money is the retail wealth-tech arm of InCred Group, a leading diversified
                financial services firm. InCred Money helps mass-affluent and retail investors
                diversify their portfolios by providing access to niche, low-ticket investment
                opportunities, which were historically available only to HNIs/ UHNIs and Corporates.
                This is in addition to traditional investment avenues including mutual funds and
                fixed deposits. The InCred Money platform will span both B2C and B2B2C verticals.
            </p>
            <h2 id="visit-website" className="font-semibold leading-[41.6px] md:mb-8">
                Visit{" "}
                <a
                    id="incred-website-link"
                    href="https://www.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.incredmoney.com
                </a>{" "}
                to know more.
            </h2>
            <p id="fd-data" className="mb-8 text-base text-neutral-500">
                Fixed Deposits are offered by Banks/NBFCs and are regulated by the Reserve Bank of
                India. ETA Fintech Private Limited, under the brand name of InCred Money, is acting
                in the capacity of Sub Agent/Referral Partner for distribution of Fixed Deposits of
                Banks and NBFCs. The funds transferred by the customer for the Fixed Deposits are
                directly credited to the regulated entity offering the Fixed Deposit product. Fixed
                Deposits are offered to Resident Indians above the age of 18 who have a PAN & an
                Aadhaar. Interest rates are subject to change. T&C apply.
            </p>
            <p
                id="notes-title"
                className="text-2xl font-semibold leading-[41.6px] md:mb-2 md:text-4xl"
            >
                Notes:
            </p>
            <img
                id="fd-announcement-image"
                className="mb-8"
                src="https://assets.incredmoney.com/images/webp/fd-announcement.webp"
                alt="FD Announcement"
            />
            <p id="source-info" className="mb-2 text-base text-neutral-500">
                <b>Source: RBI (FD Interest Rates are the average of Top 5 Banks), InCred Money</b>
            </p>
            <p id="rbi-data-info" className="mb-2 text-base text-neutral-500">
                According to RBI data, despite interest rates on FD dipping to as low as 5.5% in
                2021 and 2022, we have seen a significant rise in the amounts invested in FDs.
            </p>
            <p id="media-contacts-title" className="text-semibold mb-2 md:text-xl">
                Media contacts:
            </p>
            <p id="media-contact-archana" className="text-base text-neutral-500">
                Archana Parthasarathy | Concept PR |
                <a
                    id="archana-phone"
                    href="tel:9920940003"
                    className="underline hover:text-orange-500"
                >
                    {"  "} 9920940003
                </a>{" "}
                |
                <a
                    id="archana-email"
                    href={`mailto:${archana_conceptpr}`}
                    className="underline hover:text-orange-500"
                >
                    {" "}
                    {archana_conceptpr}
                </a>
            </p>
            <p id="media-contact-huda" className="mb-8 text-base text-neutral-500">
                Huda Qureshi | Concept PR |
                <a
                    id="huda-phone"
                    href="tel:7710823343"
                    className="underline hover:text-orange-500"
                >
                    {"  "}7710823343
                </a>{" "}
                |
                <a
                    id="huda-email"
                    href={`mailto:${huda_conceptpr}`}
                    className="underline hover:text-orange-500"
                >
                    {" "}
                    {huda_conceptpr}
                </a>
            </p>

            <h2
                id="press-release-title"
                className="text-4xl font-semibold leading-[41.6px] md:mb-2 md:text-6xl"
            >
                Press Release
            </h2>
            <p
                id="press-release-subtitle"
                className="mb-4 text-2xl font-semibold md:mb-8 md:text-4xl md:leading-[41.6px]"
            >
                InCred Money introduces ‘InCred 1.5x Nifty Accelerator MLD’ - A <i>‘Free-Hit’</i>{" "}
                for your Portfolio
            </p>
            <p id="press-release-content-1" className="mb-8 text-base text-neutral-500">
                The product offers 1.5 times Nifty 50 Index Returns with 100% Principal Protection,
                at Maturity.
            </p>
            <p id="press-release-content-2" className="mb-8 text-base text-neutral-500">
                Mumbai, <b>Wednesday, 7th February 2024:</b> After the successful launch of the
                first Market Linked Debenture (MLD) offering on its platform in August 2023, InCred
                Money has now listed a new innovative MLD on its platform for investors looking to
                participate in India’s equity story with an added layer of safety.
            </p>
            <p id="press-release-content-3" className="mb-8 text-base text-neutral-500">
                The <b>InCred 1.5x Nifty Accelerator MLD</b> (hereafter referred to as 1.5x Nifty
                MLD) is issued by InCred Financial Services Limited (IFSL), a leading new age
                financial services company. InCred attained the ‘Unicorn’ status in December 2023.
                IFSL has recorded a PBT of INR 298 Cr for the period Apr-Dec 2023.
            </p>
            <p id="press-release-content-4" className="mb-8 text-base text-neutral-500">
                The 1.5x Nifty MLD provides a return equivalent to 1.5 times (150%) of the Nifty 50
                Index returns, capped at a maximum of 33% total returns at Maturity in Apr’26 (~26
                months) *. In addition, the MLD offers 100% Principal Protection at Maturity that
                serves as a safeguard against unforeseen risks. The product has a credit rating of
                Crisil PP-MLD A+ with ‘Stable’ Outlook.
            </p>
            <p id="market-outlook" className="mb-8 text-base text-neutral-500">
                With a resilient domestic economy, India shines bright on the global stage, and is
                rightly seeing investor enthusiasm. This presents a favourable opportunity to
                participate in India’s equity markets and MLDs offer a remarkably risk-efficient way
                to do this.
            </p>
            <p id="ceo-quote" className="mb-8 text-base text-neutral-500">
                Commenting on the launch of the MLD, <b>Vijay Kuppa, CEO at InCred Money</b> said,
                “Indian Equity Markets are near All Time Highs and investor interest is still very
                strong. This is the time when one needs to evaluate their portfolio from a
                risk-return perspective. With 100% Principal Protection on the downside and 1.5
                times of Nifty 50 returns on the upside at Maturity, the MLD will help you stay
                invested in the stock market with confidence. The ‘Anytime Liquidity’# feature on
                the InCred Money platform also offers the flexibility and convenience when managing
                your investments.”
            </p>
            <h2
                id="about-mlds-title"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About Market Linked Debentures (MLDs)
            </h2>
            <p id="about-mlds-content" className="mb-8 text-base text-neutral-500">
                A globally popular investment category, MLDs in India have thus far only been
                accessible to large institutions and ultra-high-net-worth individuals due to
                high-ticket sizes. MLDs bridge the gap between Equity and Debt by giving Equity like
                returns with Fixed Income like security. The MLD offering on the InCred Money
                platform is in line with their vision to empower retail and mass affluent investors
                seeking better risk-adjusted returns by giving them access to alternate investment
                options starting from just INR 1 lakh.
            </p>
            <h2
                id="about-incred-title"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About InCred Money
            </h2>
            <p id="about-incred-content" className="mb-8 text-base text-neutral-500">
                InCred Money is the retail wealth-tech arm of InCred Group, a leading diversified
                financial services firm. InCred Money helps mass-affluent and retail investors
                diversify their portfolios by providing access to niche, low-ticket investment
                opportunities, which were historically available only to HNIs/ UHNIs and Corporates.
                This is in addition to traditional investment avenues including mutual funds and
                fixed deposits. The InCred Money platform will span both B2C and B2B2C verticals.
            </p>
            <h2 id="visit-website" className="font-semibold md:mb-8 md:leading-[41.6px]">
                Visit{" "}
                <a
                    id="incred-website-link"
                    href="https://www.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.incredmoney.com
                </a>{" "}
                to know more.
            </h2>
            <p id="returns-note" className="mb-2 text-base text-neutral-500">
                *Returns will be subject to actual Nifty 50 levels on Initial Observation dates and
                Final Observation dates.
            </p>
            <p id="liquidity-note" className="mb-8 text-base text-neutral-500">
                #Anytime Liquidity – Please{" "}
                <a
                    id="liquidity-tc"
                    className="underline hover:text-orange-500"
                    href="https://www.incredmoney.com/terms-of-use/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    click here
                </a>{" "}
                to refer to the T&C. Cost of liquidity provided is 2% of latest market to market
                price per unit.
            </p>
            <h2 id="terms-title" className="font-semibold md:mb-8 md:leading-[41.6px]">
                <a
                    id="terms-link"
                    href="https://www.incredmoney.com/terms-of-use/"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    T&C Apply
                </a>
            </h2>
            <p id="disclaimer-1" className="mb-2 text-base text-neutral-500">
                Disclaimer: Investments in debt securities/municipal debt securities/securitised
                debt instruments are subject to risks including delay and/or default in payment.
                Read all the offer related documents carefully. These offer documents are available
                on{" "}
                <a
                    href="https://bonds.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    bonds.incredmoney.com
                </a>
                .
            </p>
            <p id="disclaimer-2" className="mb-8 text-base text-neutral-500">
                ORO FINANCIAL CONSULTANTS PRIVATE LIMITED is registered as a Stock Broker in Cash
                and New Debt Segment of BSE Limited (Member Code: 6821) having SEBI registration
                number: INZ000312534, Registered as an Online Bond Platform Provider in BSE. This
                document neither an Offer Document nor a Prospectus and does not constitute an Offer
                under the applicable laws.
            </p>

            <p
                id="press-release-title"
                className="text-4xl font-semibold leading-[41.6px] md:mb-2 md:text-6xl"
            >
                Press Release
            </p>
            <h2
                id="product-introduction"
                className="mb-4 text-2xl font-semibold md:mb-8 md:text-4xl md:leading-[41.6px]"
            >
                InCred Money introduces &apos;InCred 1.5x Nifty Accelerator MLD&apos; – A &#39;
                <span className="italic">Free-Hit</span> &#39; for your Portfolio
            </h2>
            <p id="product-summary" className="mb-8 text-base text-neutral-500">
                The product offers 1.5 times Nifty 50 Index Returns with 100% Principal Protection,
                at Maturity.
            </p>
            <p id="product-launch-details" className="mb-8 text-base text-neutral-500">
                Mumbai, <b>Wednesday, 7th February 2024:</b> After the successful launch of the
                first Market Linked Debenture (MLD) offering on its platform in August 2023, InCred
                Money has now listed a new innovative MLD on the platform for investors looking to
                participate in India&#39;s equity story with an added layer of safety.
            </p>

            <p id="product-issuer-details" className="mb-8 text-base text-neutral-500">
                The <b>InCred 1.5x Nifty Accelerator MLD</b> (hereafter referred to as 1.5x Nifty
                MLD) is issued by InCred Financial Services Limited (IFSL), a leading new age
                financial services company. InCred attained the &#39;Unicorn&#39; status in December
                2023. IFSL has recorded a PBT of INR 298 Cr for the period Apr-Dec 2023.
            </p>

            <p id="product-returns" className="mb-8 text-base text-neutral-500">
                {`The 1.5x Nifty MLD provides a return equivalent to 1.5 times (150%) of the Nifty 50 Index returns, capped at a maximum of 33% total returns at Maturity in Apr'26 (~26 months) *. In addition, the MLD offers 100% Principal Protection at Maturity that serves as a safeguard against unforeseen risks. The product has a credit rating of 'CRISIL AA/Stable' Outlook.`}
            </p>
            <p id="investment-opportunity" className="mb-8 text-base text-neutral-500">
                {`With a resilient domestic economy, India shines bright on the global stage, and is rightly seeing investor enthusiasm. This presents a favourable opportunity to participate in India's equity markets and MLDs offer a remarkably risk-efficient way to do this.`}
            </p>
            <p id="ceo-quote" className="mb-8 text-base text-neutral-500">
                Commenting on the launch of the MLD, <b>Vijay Kuppa, CEO at InCred Money</b> said,
                &quot;Indian Equity Markets are near All Time Highs and investor interest is still
                very strong. This is the time when one needs to evaluate their portfolio from a
                risk-return perspective. With 100% Principal Protection on the downside and 1.5
                times of Nifty 50 returns on the upside at Maturity, the MLD will help you stay
                invested in the stock market with confidence. The &#39;Anytime Liquidity&#39;
                <sup>#</sup> feature on the InCred Money platform also offers the flexibility and
                convenience when managing your investments.&quot;
            </p>
            <h2
                id="about-mlds"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About Market Linked Debentures (MLDs)
            </h2>
            <p id="mld-explanation" className="mb-8 text-base text-neutral-500">
                A globally popular investment category, MLDs in India have thus far only been
                accessible to large institutions and ultra-high-net-worth individuals due to
                high-ticket sizes. MLDs bridge the gap between Equity and Debt by giving Equity-like
                returns with Fixed Income-like security. The MLD offering on the InCred Money
                platform is in line with their vision to empower retail and mass affluent investors
                seeking better risk-adjusted returns by giving them access to alternate investment
                options starting from just INR 1 lakh.
            </p>
            <h2
                id="about-incred-money"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About InCred Money
            </h2>
            <p id="incred-money-details" className="mb-8 text-base text-neutral-500">
                InCred Money is the retail wealth-tech arm of InCred Group, a leading diversified
                financial services firm. InCred Money helps mass-affluent and retail investors
                diversify their portfolios by providing access to niche, low-ticket investment
                opportunities, which were historically available only to HNIs/ UHNIs and Corporates.
                This is in addition to traditional investment avenues including mutual funds and
                fixed deposits. The InCred Money platform will span both B2C and B2B2C verticals.
            </p>
            <p id="website-link" className="mb-8 font-semibold md:mb-8 md:leading-[41.6px]">
                Visit{" "}
                <a
                    href="http://www.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.incredmoney.com
                </a>{" "}
                to know more.
            </p>
            <p id="return-conditions" className="mb-8 text-base text-neutral-500">
                *Returns will be subject to actual Nifty 50 levels on Initial Observation dates and
                Final Observation dates. #Anytime Liquidity - Please{" "}
                <a
                    href="https://www.incredmoney.com/terms-of-use/"
                    className="underline hover:text-orange-500"
                >
                    click here
                </a>{" "}
                to refer to the T&C. Cost of liquidity provided is 2% of latest market-to-market
                price per unit.
            </p>
            <h2 id="terms-conditions" className="font-semibold leading-[41.6px] md:mb-2">
                <a
                    href="https://www.incredmoney.com/terms-of-use/"
                    className="underline hover:text-orange-500"
                >
                    T&C Apply
                </a>
            </h2>
            <p id="disclaimer" className="mb-8 text-base text-neutral-500">
                Disclaimer: Investments in debt securities/municipal debt securities/securitised
                debt instruments are subject to risks including delay and/or default in payment.
                Read all the offer-related documents carefully. These offer documents are available
                on{" "}
                <a href="http://bonds.incredmoney.com" className="underline hover:text-orange-500">
                    bonds.incredmoney.com
                </a>
                .
            </p>
            <p id="regulatory-info" className="mb-8 text-base text-neutral-500">
                ORO FINANCIAL CONSULTANTS PRIVATE LIMITED is registered as a Stock Broker in Cash
                and New Debt Segment of BSE Limited (Member Code: 6821) having SEBI registration
                number: INZ000312534, Registered as an Online Bond Platform Provider in BSE. This
                document is neither an Offer Document nor a Prospectus and does not constitute an
                Offer under the applicable laws.
            </p>

            <p
                id="press-release-title"
                className="centered text-4xl font-semibold leading-[41.6px] md:mb-2 md:text-6xl"
            >
                Press Release
            </p>

            <h2
                id="product-introduction"
                className="centered mb-4 text-2xl font-semibold md:mb-8 md:text-4xl md:leading-[41.6px]"
            >
                InCred Money Unveils Market Linked Debentures (MLDs) - an Innovative Investment
                Product for Retail Investors
            </h2>

            <p id="product-summary" className="mb-8 text-base text-neutral-500">
                The product offers Equity market participation with 100% Principal Protection and a
                Minimum 14% Returns at Maturity
            </p>

            <p id="product-launch-details" className="mb-8 text-base text-neutral-500">
                Mumbai: <b>Wednesday, 16th August 2023:</b> &quot;InCred Money (
                <a
                    href="https://www.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.incredmoney.com
                </a>
                ) is launching its maiden issue of Market-Linked Debentures (MLDs) for retail
                investors.
            </p>

            <p id="mld-accessibility" className="mb-8 text-base text-neutral-500">
                A globally popular investment category, MLDs in India have thus far only been
                accessible to large institutions and ultra-high-net-worth individuals due to
                high-ticket sizes.
            </p>

            <p id="issuer-details" className="mb-8 text-base text-neutral-500">
                {`This maiden MLD offering, the InCred Nifty Balanced MLD Aug'25, is issued by InCred
    Financial Services Limited, which is A+ rated and one of the leading NBFCs in its
    market segments. The product is exclusively available on the InCred Money platform.`}
            </p>

            <p id="returns-details" className="mb-8 text-base text-neutral-500">
                The issue offers 100% Principal Protection at Maturity, and the returns are linked
                to the Equity Market Benchmark Nifty 50 Index. It provides a minimum total return of
                14% at Maturity (31st Aug 2025) and offers an upside participation in the Nifty 50
                Index that can lead to an overall return of 30% at Maturity.
            </p>

            <p id="ceo-quote-bhupinder" className="mb-8 text-base text-neutral-500">
                {`Bhupinder Singh, Founder and Group CEO of InCred, is very excited about this launch.
    According to him "This MLD product enables investors to participate in the Indian
    equity growth story, with principal protection and a minimum guaranteed return.
    InCred is known for cutting edge product innovation and this issue is yet another
    example of that".`}
            </p>

            <p id="ceo-quote-vijay" className="mb-8 text-base text-neutral-500">
                {`Commenting on the launch of the MLD, Vijay Kuppa, CEO at InCred Money said, "Today's
    investors are looking for more than just conventional investment products. They need
    solutions that combine the twin requirements of stability and growth. The MLDs on
    our platform address this demand by bridging the gap between fixed-income and
    market-linked returns. To address the challenge of illiquid secondary markets for
    debt instruments, we are also offering the feature of 'Anytime Liquidity' on the
    InCred Money platform. We understand the value liquidity has for debt market
    participants, and this step strives to offer our investors with the flexibility and
    convenience when managing their investments."`}
            </p>

            <p id="previous-product" className="mb-8 text-base text-neutral-500">
                This is the second product from InCred Money after the successful launch of their
                Corporate Bond offering in June 2023 and is in line with their vision to empower
                retail and mass affluent investors seeking better risk-adjusted returns by giving
                them access to alternate investment options starting from just ₹1 lakh.
            </p>

            <h2
                id="about-incred-group"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About InCred Group
            </h2>

            <p id="incred-money-details" className="mb-8 text-base text-neutral-500">
                InCred Money is the retail wealth-tech arm of InCred Group, a leading diversified
                financial services firm. InCred Money helps mass-affluent and retail investors
                diversify their portfolios by providing access to niche, low-ticket investment
                opportunities, which were historically available only to HNIs/ UHNIs and Corporates.
                This is in addition to traditional investment avenues including mutual funds and
                fixed deposits. The InCred Money platform will span both B2C and B2B2C verticals.
            </p>

            <p id="website-link" className="mb-8 font-semibold md:mb-8 md:leading-[41.6px]">
                Visit{" "}
                <a
                    id="incred-website"
                    href="http://www.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.incredmoney.com
                </a>{" "}
                to know more.
            </p>

            <p id="terms-conditions" className="mb-8 text-base text-neutral-500">
                <strong>
                    <a
                        id="terms-link"
                        href="http://www.incredmoney.com/terms-of-use"
                        className="underline hover:text-orange-500"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        *T&C Apply
                    </a>
                </strong>
            </p>

            <p id="disclaimer" className="mb-8 text-base text-neutral-500">
                Disclaimer: Investments in debt securities are subject to risks. Read all the
                offer-related documents carefully.
            </p>
            <p
                id="press-release-title"
                className="centered text-4xl font-semibold leading-[41.6px] md:mb-2 md:text-6xl"
            >
                Press Release
            </p>
            <h2
                id="product-introduction"
                className="centered mb-4 text-2xl font-semibold md:mb-8 md:text-4xl md:leading-[41.6px]"
            >
                {`"InCred Money Launches Platform Enabling Retail Investors to Invest in Alternate
    Assets Introduces First Offering with Fixed Returns of 12.5% p.a."`}
            </h2>

            <p id="product-launch-details" className="mb-8 text-base text-neutral-500">
                Mumbai: <b>Friday, 23 June 2023:</b> &quot;InCred Money (
                <a
                    href="https://www.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.incredmoney.com
                </a>
                ) launches its first product, corporate bonds, with an issuance that offers
                investors fixed returns of 12.5% p.a. (XIRR)*. The investor-first, curated alternate
                asset platform enables diversification and wealth creation through a user-friendly
                process, democratizing access to products previously available only to Ultra HNIs
                and Institutions.&quot;
            </p>

            <p id="company-background" className="mb-8 text-base text-neutral-500">
                InCred Money is part of the InCred Group and was launched with the acquisition of
                Orowealth, one of the leading retail-focused digital investment platforms that
                managed an AuM of INR 1,150+ Cr. The InCred Money platform will span both B2C and
                B2B2C verticals, providing a comprehensive suite of investment products and services
                for both Investors and Financial Advisors.
            </p>

            <p id="competitive-advantages" className="mb-8 text-base text-neutral-500">
                Under the InCred fold, InCred Money will have significant competitive advantages
                with access to a deep network of issuers and industry leading credit & risk
                assessment capabilities. In addition to its fintech capabilities, InCred Money will
                also have the added advantage of the support of a large financial services
                organization. This will greatly help in the journey of making alternate assets easy,
                trustworthy, and lucrative for the end investor.
            </p>

            <p id="ceo-quote-vijay" className="mb-8 text-base text-neutral-500">
                <b>Commenting on the launch Vijay Kuppa, CEO, InCred Money said,</b> “We are excited
                to launch the first of our many products that will help retail investors boost their
                returns, protect against inflation, and diversify their overall wealth portfolio.
                Our platform will make it easier than ever for investors to access the bond market
                and will be a valuable tool for both novice and expert level investors. We are
                committed to providing our clients with the best possible investment experience, and
                we believe that InCred Money will help investors build well diversified and
                resilient portfolios for achieving their financial goals.”
            </p>

            <p id="ceo-quote-bhupinder" className="mb-8 text-base text-neutral-500">
                <b>Bhupinder Singh, Founder and CEO of InCred Group, said “</b> I strongly believe
                that the democratization of investment opportunities covering the Mass Affluent and
                Retail segments will be driven by digital platforms that unlock access to
                non-traditional assets for investors as well as their advisors. This maiden product
                offering under our InCred Money brand is the first step towards enabling retail
                clients to diversify into the alternates space and will be followed by many more
                interesting opportunities for them to generate potential alpha.”
            </p>

            <h2
                id="about-incred-group"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About InCred Group
            </h2>

            <p id="incred-money-details" className="mb-8 text-base text-neutral-500">
                InCred Money is the retail wealth-tech arm of InCred Group, a leading diversified
                financial services firm. InCred Money helps mass-affluent and retail investors
                diversify their portfolios by providing access to niche, low-ticket investment
                opportunities, which were historically available only to HNIs/ UHNIs and Corporates.
                This is in addition to traditional investment avenues including mutual funds and
                fixed deposits. The InCred Money platform will span both B2C and B2B2C verticals.
            </p>

            <p id="website-link" className="mb-8 font-semibold md:mb-8 md:leading-[41.6px]">
                Visit{" "}
                <a
                    id="incred-website"
                    href="http://www.incredmoney.com"
                    className="underline hover:text-orange-500"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.incredmoney.com
                </a>{" "}
                to know more.
            </p>

            <p id="terms-conditions" className="mb-8 text-base text-neutral-500">
                <strong>
                    <a
                        id="terms-link"
                        href="http://www.incredmoney.com/terms-of-use"
                        className="underline hover:text-orange-500"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        *T&C Apply
                    </a>
                </strong>
            </p>

            <p id="disclaimer" className="mb-8 text-base text-neutral-500">
                Disclaimer: Investments in debt securities are subject to risks. Read all the
                offer-related documents carefully.
            </p>
            <img
                src="https://assets.incredmoney.com/images/webp/incred_logo.webp"
                alt="logo-url"
                className="mb-4 ml-auto h-[70px] w-[140px] text-left md:mt-4"
            />

            <p
                id="press-release-title"
                className="centered text-4xl font-semibold leading-[41.6px] md:mb-4 md:text-6xl"
            >
                Press Release
            </p>
            <p id="aum-and-team" className="mb-8 text-base text-neutral-500">
                Date: 02/01/2023
            </p>
            <h2
                id="headline"
                className="centered mb-4 text-2xl font-semibold md:mb-8 md:text-4xl md:leading-[41.6px]"
            >
                InCred Capital forays into retail wealth-tech with the launch of InCred Money.
            </h2>

            <ul
                id="key-highlights"
                className="mb-8 list-inside list-disc text-base text-neutral-500"
            >
                <li id="highlight-1">
                    InCred Money has been launched with the acquisition of Orowealth, one of the
                    leading retail-focused digital investment platforms.
                </li>
                <li id="highlight-2">
                    The InCred Money platform will span both B2C and B2B2C verticals, providing a
                    comprehensive suite of investment products and services.
                </li>
                <li id="highlight-3">
                    Vijay Kuppa, co-founder of Orowealth, will spearhead InCred Money as its CEO.
                </li>
            </ul>

            <p id="incred-market-entry" className="mb-8 text-base text-neutral-500">
                InCred Capital is set to enter the retail wealth-tech industry with the launch of
                ‘InCred Money’. This will be InCred Capital’s second pillar in the fast-growing
                Indian wealth market, following its previous success in the Ultra / High Net Worth
                segment under the InCred Wealth brand.
            </p>

            <p id="incred-wealth-growth" className="mb-8 text-base text-neutral-500">
                InCred Wealth has seen tremendous growth since launch, becoming one of the fastest
                growing wealth management firms in the country and achieving a milestone of INR
                15,000 Cr in Assets under Management (AuM) within 2 years, driven by a team of 100+
                Private Bankers.
            </p>

            <p id="incred-money-expansion" className="mb-8 text-base text-neutral-500">
                With the launch of InCred Money, InCred Capital will now plant its flag in the
                mass-affluent and retail space.
            </p>

            <p id="orowealth-acquisition" className="mb-8 text-base text-neutral-500">
                InCred Money has been launched with the acquisition of Orowealth in an all-cash
                deal, pending necessary clearances. Orowealth is a leading retail-focused digital
                investment platform that helps retail investors diversify their portfolio by
                providing access to niche, low-ticket investment opportunities, which were
                historically available only to HNIs/UHNIs and Corporates. This is in addition to
                traditional investment avenues including mutual funds and fixed deposits, which are
                a part of Orowealth’s offerings.
            </p>

            <p id="aum-and-team" className="mb-8 text-base text-neutral-500">
                The acquisition brings AuM of INR 1,100+ Cr along with a robust technology platform
                and an experienced team to InCred Money. Vijay Kuppa, the co-founder of Orowealth,
                will lead InCred Money as the CEO going forward.
            </p>

            <p id="b2b2c-offering" className="mb-8 text-base text-neutral-500">
                The InCred Group will aim to provide InCred Money with access to its full suite of
                product capabilities. InCred Money will also develop a B2B2C offering by leveraging
                technology to effectively integrate a wide network of Independent Financial Advisors
                (IFA) across the country, giving them the ability to tap into the class-leading
                products and solutions for the benefit of their end customers.
            </p>

            <p id="ceo-bhupinder-quote" className="mb-8 text-base text-neutral-500">
                <b>Bhupinder Singh</b>, Founder and Group CEO of InCred Group, said “In the next
                decade, the democratization of investment opportunities covering the Mass Affluent
                and Retail segments will be driven by digital platforms that unlock access to
                non-traditional assets for investors as well as their advisors. This will help to
                create a new market worth tens of billions in AUM. With the launch of the InCred
                Money platform, we are committed to offering best-in-class products to these rapidly
                evolving customer segments in keeping with our vision to meet the financial needs of
                every Indian family.”
            </p>

            <p id="ceo-vijay-quote" className="mb-8 text-base text-neutral-500">
                Commenting on the transaction, <b>Vijay Kuppa</b> said “There is a growing demand
                for non-traditional investment assets from Mass Affluent and Retail investors due to
                rising income levels and greater awareness. We are addressing this massive demand by
                putting together a suite of carefully curated products and solutions. I am excited
                to be joining the InCred Group and leading a key pillar of their overall strategy. I
                am confident that InCred Money will play a crucial role in making investments easy,
                trustworthy, and lucrative for the end investor.”
            </p>

            <h2
                id="about-incred-group"
                className="text-2xl font-semibold leading-[41.6px] md:mb-8 md:text-4xl"
            >
                About InCred Group
            </h2>

            <p id="incred-group-details" className="mb-8 text-base text-neutral-500">
                The InCred Group is a class-leading diversified financial services firm which
                comprises two distinct businesses - ‘InCred Finance’, a new-age lending-focused
                NBFC, and ‘InCred Capital’, which is the institutional, wealth management, and asset
                management platform of the group.
            </p>

            <p id="contact-info" className="mb-8 text-base text-neutral-500">
                Please e-mail
                <a
                    id="contact-email"
                    href={"mailto:" + ICM_MAIL}
                    className="ml-2 mr-2 underline hover:text-orange-600"
                >
                    {ICM_MAIL}
                </a>
                for any queries.
            </p>
        </section>
    );
};

export default PressRelease;
